// Global Components
import * as React from 'react';
import {
  Route,
  Routes,
} from 'react-router-dom';

// Components
import AuthRoute from './AuthRoute';

// Pages
import RegattasPage from '../components/pages/RegattasPage';

import RegattaSettingsPage from '../components/pages/RegattaSettingsPage';
import RegattaBoardPage from '../components/pages/RegattaBoardPage';
import RegattaCoursesPage from '../components/pages/RegattaCoursesPage';
import RegattaCoursePage from '../components/pages/RegattaCoursePage';
import RegattaEntriesPage from '../components/pages/RegattaEntriesPage';
import RegattaEntryRatingsPage from '../components/pages/RegattaEntryRatingsPage';
import RegattaResultsPage from '../components/pages/RegattaResultsPage';
import RegattaResultOverallsPage from '../components/pages/RegattaResultOverallsPage';
import RegattaResultDiplomasPage from '../components/pages/RegattaResultDiplomasPage';
import RegattaInfoPage from '../components/pages/RegattaInfoPage';
import RegattaLogsPage from '../components/pages/RegattaLogsPage';

import ChampionshipsPage from '../components/pages/ChampionshipsPage';
import ChampionshipPage from '../components/pages/ChampionshipPage';

import AdminAdminAccessTokensPage from '../components/pages/AdminAdminAccessTokensPage';
import AdminAdminSocialUsersPage from '../components/pages/AdminAdminSocialUsersPage';
import AdminAdminsPage from '../components/pages/AdminAdminsPage';
import AdminAdvertisementsPage from '../components/pages/AdminAdvertisementsPage';
import AdminBannersPage from '../components/pages/AdminBannersPage';
import AdminDocumentsPage from '../components/pages/AdminDocumentsPage';
import AdminCrewmemberAccessTokensPage from '../components/pages/AdminCrewmemberAccessTokensPage';
import AdminCrewmemberSocialUsersPage from '../components/pages/AdminCrewmemberSocialUsersPage';
import AdminCrewmembersPage from '../components/pages/AdminCrewmembersPage';
import AdminCustomPagesPage from '../components/pages/AdminCustomPagesPage';
import AdminEntriesPage from '../components/pages/AdminEntriesPage';
import AdminEntriesUnmatchedPage from '../components/pages/AdminEntriesUnmatchedPage';
import AdminEntryRatingsPage from '../components/pages/AdminEntryRatingsPage';
import AdminRatingsPage from '../components/pages/AdminRatingsPage';
import AdminGroupsPage from '../components/pages/AdminGroupsPage';
import AdminRegattaNotificationCrewmembersPage from '../components/pages/AdminRegattaNotificationCrewmembersPage';
import AdminRegattaNotificationsPage from '../components/pages/AdminRegattaNotificationsPage';
import AdminRegattaPaymentDiscountsPage from '../components/pages/AdminRegattaPaymentDiscountsPage';
import AdminRegattaPaymentsPage from '../components/pages/AdminRegattaPaymentsPage';
import AdminRegionSeasonsPage from '../components/pages/AdminRegionSeasonsPage';
import AdminRegionsPage from '../components/pages/AdminRegionsPage';

import ProfilePage from '../components/pages/ProfilePage';

// Pages
import NotFoundPage from '../components/pages/NotFoundPage';
import LoginPage from '../components/pages/LoginPage';

const Router = function () {
  return (
    <Routes>
      <Route
        element={(
          <AuthRoute>
            <RegattaSettingsPage />
          </AuthRoute>
        )}
        key={'regatta_settings'}
        path={'/'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaSettingsPage />
          </AuthRoute>
        )}
        key={'regatta_settings'}
        path={'/regatta/settings'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaBoardPage />
          </AuthRoute>
        )}
        key={'regatta_board'}
        path={'/regatta/board'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaEntriesPage />
          </AuthRoute>
        )}
        key={'regatta_entries'}
        path={'/regatta/entries'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaEntryRatingsPage />
          </AuthRoute>
        )}
        key={'regatta_entry_ratings'}
        path={'/regatta/entry/:RegattaEntryId/ratings'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaCoursesPage />
          </AuthRoute>
        )}
        key={'regatta_courses'}
        path={'/regatta/courses'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaCoursePage />
          </AuthRoute>
        )}
        key={'regatta_course'}
        path={'/regatta/course/:RegattaCourseId'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaResultsPage />
          </AuthRoute>
        )}
        key={'regatta_results'}
        path={'/regatta/results'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaResultOverallsPage />
          </AuthRoute>
        )}
        key={'regatta_result_overalls'}
        path={'/regatta/result_overalls'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaResultDiplomasPage />
          </AuthRoute>
        )}
        key={'regatta_result_diplomas'}
        path={'/regatta/result_diplomas'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaInfoPage />
          </AuthRoute>
        )}
        key={'regatta_info'}
        path={'/regatta/info'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattaLogsPage />
          </AuthRoute>
        )}
        key={'regatta_logs'}
        path={'/regatta/logs'}
      />
      <Route
        element={(
          <AuthRoute>
            <RegattasPage />
          </AuthRoute>
        )}
        key={'regattas'}
        path={'/regattas'}
      />
      <Route
        element={(
          <AuthRoute>
            <ChampionshipsPage />
          </AuthRoute>
        )}
        key={'championships'}
        path={'/championships'}
      />
      <Route
        element={(
          <AuthRoute>
            <ChampionshipPage />
          </AuthRoute>
        )}
        key={'championship'}
        path={'/championship/:ChampionshipId'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminEntriesPage />
          </AuthRoute>
        )}
        key={'admin_entries'}
        path={'/admin/entries'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminEntriesUnmatchedPage />
          </AuthRoute>
        )}
        key={'admin_entries_unmatched'}
        path={'/admin/entries_unmatched'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminEntryRatingsPage />
          </AuthRoute>
        )}
        key={'admin_entry_ratings'}
        path={'/admin/entry/:EntryId/ratings'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRatingsPage />
          </AuthRoute>
        )}
        key={'admin_ratings'}
        path={'/admin/ratings'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminCrewmembersPage />
          </AuthRoute>
        )}
        key={'admin_crewmembers'}
        path={'/admin/crewmembers'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminCrewmemberAccessTokensPage />
          </AuthRoute>
        )}
        key={'admin_crewmember_access_tokens'}
        path={'/admin/crewmember/:CrewmemberId/access_tokens'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminCrewmemberSocialUsersPage />
          </AuthRoute>
        )}
        key={'admin_crewmember_social_users'}
        path={'/admin/crewmember/:CrewmemberId/social_users'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminDocumentsPage />
          </AuthRoute>
        )}
        key={'admin_documents'}
        path={'/admin/documents'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminBannersPage />
          </AuthRoute>
        )}
        key={'admin_buttons'}
        path={'/admin/banners'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminAdvertisementsPage />
          </AuthRoute>
        )}
        key={'admin_advertisements'}
        path={'/admin/advertisements'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminCustomPagesPage />
          </AuthRoute>
        )}
        key={'admin_custom_pages'}
        path={'/admin/custom_pages'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminGroupsPage />
          </AuthRoute>
        )}
        key={'admin_groups'}
        path={'/admin/groups'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRegattaNotificationsPage />
          </AuthRoute>
        )}
        key={'admin_regatta_notifications'}
        path={'/admin/regatta_notifications'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRegattaNotificationCrewmembersPage />
          </AuthRoute>
        )}
        key={'admin_regatta_notification_crewmembers'}
        path={'/admin/regatta_notification/:RegattaNotificationId/crewmembers'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRegattaPaymentsPage />
          </AuthRoute>
        )}
        key={'admin_regatta_payments'}
        path={'/admin/regatta_payments'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRegattaPaymentDiscountsPage />
          </AuthRoute>
        )}
        key={'admin_regatta_payment_discounts'}
        path={'/admin/regatta_payment_discounts'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRegionsPage />
          </AuthRoute>
        )}
        key={'admin_regions'}
        path={'/admin/regions'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminRegionSeasonsPage />
          </AuthRoute>
        )}
        key={'admin_region_seasons'}
        path={'/admin/region/:RegionId/seasons'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminAdminsPage />
          </AuthRoute>
        )}
        key={'admin_admins'}
        path={'/admin/admins'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminAdminAccessTokensPage />
          </AuthRoute>
        )}
        key={'admin_admin_access_tokens'}
        path={'/admin/admin/:AdminId/access_tokens'}
      />
      <Route
        element={(
          <AuthRoute>
            <AdminAdminSocialUsersPage />
          </AuthRoute>
        )}
        key={'admin_admin_social_users'}
        path={'/admin/admin/:AdminId/social_users'}
      />
      <Route
        element={(
          <AuthRoute>
            <ProfilePage />
          </AuthRoute>
        )}
        key={'profile'}
        path={'/profile'}
      />
      <Route
        element={(<LoginPage />)}
        key={'login'}
        path={'/login'}
      />
      <Route
        element={(<NotFoundPage />)}
        key={'not_found'}
        path={'*'}
      />
    </Routes>
  );
};

export default Router;
